// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"224":"435de8c0","424":"da8631f1","463":"637a9f29","926":"d6f21c07"}[chunkId] + ".css";
};